import { render, staticRenderFns } from "./addAkcd.vue?vue&type=template&id=2f3154f7"
import script from "./addAkcd.vue?vue&type=script&lang=js"
export * from "./addAkcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports